// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z3Dry","image":"Header_image__2ndyA","name":"Header_name__1CHlP","info":"Header_info__iEclS","infoRow":"Header_infoRow__3jxf5"};